module.exports = __webpack_public_path__ + "static/img/phyto-res-logo.0285e76d.svg";